module.exports = __webpack_public_path__ + "logo.png?87e8f8d06f5b0d5c781ab45f209e0e5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 10
// module chunks = 0